import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import LdapGroupMappingContainer from '../ldapGroupMapping';
import TeamsTabs from './teamsTabs';
import Permissions from '../../../services/enums/permissions';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import { asArray } from '../../../services/utils';
import { isUserPermissionsInclude } from '../../../services/autorization';

@inject('translationsStore', 'teamsStore', 'rootLdapStore', 
    'ldapTeamMappingStore', 'oidcStore', 'configurationsStore') @observer
export default class TeamsTabsContainer extends Component {

    handleActive = tab => {

        this.props.teamsStore.setSelectedTabId(tab.props['value']);
    }

    setSelectedTabId = _ => {

        this.props.teamsStore.setSelectedTabId(1);
    }

    isPermitted = _ => {

        const currentUser = this.props.oidcStore.currentUser;
        const arr = asArray(currentUser.profile['access-control-permissions']);
        const p = isUserPermissionsInclude(arr);
        const permit = p(Permissions.manageAuthenticationProviders);

        return permit;
    }

    render() {

        const permit = this.isPermitted();
        const shouldLoadLDAPServers = permit && this.props.rootLdapStore.ldapServers === undefined && this.props.configurationsStore.isMultitenancyMode === false;

        if (shouldLoadLDAPServers || this.props.teamsStore.selectedTeamId === undefined) {
            
            return <div style={{height: '65vh'}}><ScreenLoaderContainer /></div>;
        }

        const tabs = [
            { 
                id: 1,
                title: this.props.translationsStore.translate('MEMBERS'),
                component: this.props.grid
            }
        ];

        if (this.props.configurationsStore.isMultitenancyMode === false && permit && this.props.rootLdapStore.shouldDispalyLdapMapping) {
            
            tabs.push({ 
                id: 2,
                title: this.props.translationsStore.translate('LDAP_GROUP_MAPPING'),
                component: <LdapGroupMappingContainer />
            });
        }

        return (
            <TeamsTabs
                selectedTabId={this.props.teamsStore.selectedTabId}
                tabs={tabs}
                handleActive={this.handleActive}
                setSelectedTabId={this.setSelectedTabId}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/teamsTabs/index.jsx